import { ReferentielModel } from './referentiel.model';

export class VideoContentModel {
  public id: number = null;
  public materialNumber: string;
  public diffusionFormatId: number;
  public supportId: number;
  public ratioId: number;
  public colorId: number;
  public localisation: string;
  public duration: string;
  public origin: string;
  public isFormatRespected = false;
  public availabilityDate: string;
  public checked = false;

  public ratioLabel: string;
  public formatLabel: string;
  public colorLabel: string;
  public supportLabel: string;
  public statusLabel: string;

  public status: ReferentielModel = new ReferentielModel();
  public uuid: string;

  constructor() {}

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
